/** @jsx jsx */
import {FC} from 'react';
import {css, jsx} from '@emotion/react';
import tokens from '@flexe/ui-tokens';
import {Icon} from '@flexe/ui-components';
import {CardWithIcon} from './CardWithIcon';

export const WarningCard: FC = ({children}) => (
  <CardWithIcon
    cardStyles={css`
      background-color: ${tokens?.color.base.yellow.v50.value};
      border-color: ${tokens?.color.base.yellow.v300.value};
    `}
    icon={<Icon color={tokens?.color.base.yellow.v300.value} icon={'warning'} />}
  >
    {children}
  </CardWithIcon>
);
